class BX24Connect {
    getAuth()
    {
        return new Promise(function(resolve, reject) {
            try {
                BX24.init(resolve);
            } catch (err) {
                resolve(err);
            }
        }).then(auth => {
            let result = BX24.getAuth();
            return {
                ACCESS_TOKEN: result.access_token
            }
        });
    }
}

export default BX24Connect;